import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { createContext, useMemo, useState } from 'react';
import { noop } from 'lodash';
export var DialogContext = /*#__PURE__*/createContext({
  dialogs: [],
  addDialog: noop,
  updateDialog: noop
});
var Provider = DialogContext.Provider;
export function DialogProvider(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      dialogs = _useState2[0],
      setDialogs = _useState2[1];

  var _useState3 = useState(['fade', 'scale']),
      _useState4 = _slicedToArray(_useState3, 2),
      dialogAnimationConfig = _useState4[0],
      setDialogAnimationConfig = _useState4[1];

  var value = useMemo(function () {
    return {
      dialogs: dialogs,
      dialogAnimationConfig: dialogAnimationConfig,
      setDialogAnimationConfig: setDialogAnimationConfig,
      addDialog: function addDialog(uuid, data) {
        return setDialogs(function (state) {
          var _context;

          return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(state), [_objectSpread({
            uuid: uuid
          }, data)]);
        });
      },
      updateDialog: function updateDialog(uuid, data) {
        return setDialogs(function (state) {
          return _mapInstanceProperty(state).call(state, function (item) {
            return item.uuid === uuid ? _objectSpread(_objectSpread({}, item), data) : item;
          });
        });
      }
    };
  }, [dialogs, dialogAnimationConfig, setDialogAnimationConfig]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: value
  }, children, _mapInstanceProperty(dialogs).call(dialogs, function (_ref2) {
    var Dialog = _ref2.Dialog,
        props = _ref2.props,
        open = _ref2.open,
        uuid = _ref2.uuid;
    return open && /*#__PURE__*/React.createElement(Dialog, _extends({}, props, {
      onClose: function onClose() {
        return setDialogs(function (state) {
          return _mapInstanceProperty(state).call(state, function (i) {
            return i.uuid === uuid ? _objectSpread(_objectSpread({}, i), {}, {
              open: false
            }) : i;
          });
        });
      },
      key: uuid
    }));
  }));
}